import React from 'react';
import MediaQuery from 'react-responsive';
import './Skills.css'
import Button from '../../../components/UI/Button/Button';
import FormGrid from '../../../components/UI/FormGrid/FormGrid';
import Textbox from '../../../components/UI/Textbox/Textbox';
import Aux from '../../../hoc/Auxi/Auxi';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import Icon from '../../../components/UI/Icon/Icon';

/**
* @desc skill in candidate profile section
* @param props
* @return DOM element
*/
const Skill = (props) => {

  return (
    <div className="skilldiv">
      <div className="skilltag">
        <span>{props.skill}</span>
        <Icon icon="skill-remove" className ="skilltag-icon" onClick={() => props.handleSkillRemove(props.id)}/>
      </div>
      {/* <Textbox label={"Skill " + parseInt(props.index+1)} placeholder="" value={props.skill} onBlur={(event)=>props.handleSkillOnBlur(event)} onChange={(event) => props.handleSkillChange(event, props.index)} inValid={props.inValid}/> */}
    </div>
  )
}

/**
* @desc skills in candidate profile section
* @param props
* @return DOM element
*/
const Skills = (props) => {
  const updateText = props.skillsActive =="updated" ? "Updated" : "Update";
  const inValid = props.errorMsg !== null && props.errorPosition === "skills";
  const disabled = props.skillsActive =="update" ? 'disabled' : "";
  return (
    <Aux>
      <div className="profile-edit__item">
        <MediaQuery query="(min-device-width: 768px)">
          {/* <FormGrid grid="auto auto auto"> */}
            <div className="main-skill-div">
              {props.candidate.skills.map((skill, index) => (
                <Skill key={index} index={index} 
                  skill={skill.skill} 
                  handleSkillChange={props.handleSkillChange} 
                  handleSkillsActive={props.handleSkillsActive}  
                  inValid={inValid?"Invalid":""} 
                  handleSkillOnBlur={props.handleSkillOnBlur}
                  handleSkillRemove={props.handleSkillRemove}
                  id={skill.id}
                />
              ))}
              <Textbox placeholder="Add new skill" className="addnewtaginput" onBlur={(event)=>props.handleSkillOnBlur(event)} onChange={(e) => props.handleSkillChange(e)} value={props.skillName} onKeyPress={(e) => props.handleSkillOnEnter(e)}/>
            </div>
          {/* </FormGrid> */}
        </MediaQuery>
        
        <MediaQuery query="(max-device-width: 767px)">
          <FormGrid grid="auto">
            {props.candidate.skills.map((skill, index) => (
              <Skill key={index} 
                index={index} 
                skill={skill.skill} 
                handleSkillChange={props.handleSkillChange} 
                handleSkillsActive={props.handleSkillsActive}  
                inValid={inValid?"Invalid":""} 
              />
            ))}
          </FormGrid>
        </MediaQuery>
      </div>
      {/* <div className="profile-edit__section__buttons"> */}
        {/* <MediaQuery query="(min-device-width: 768px)">
          <Button 
            uistyle="secondary" 
            className="profile-edit__add-button" 
            onClick={props.addSkill}
          >+ Add Skill</Button>
        </MediaQuery>         */}
        {/* <MediaQuery query="(max-device-width: 767px)">
          <Button 
            uistyle="secondary" 
            className="profile-edit__add-button" 
            buttonicon="add" 
            buttonIconAlone={true} 
            onClick={props.addSkill}
          ></Button>
        </MediaQuery>   */}
        {/* <Button 
          className={props.skillsActive} 
          disabled={disabled} 
          onClick={(event)=>props.handleUpdateProfile(event,"skillsActive")}
        >{updateText}</Button> */}
      {/* </div> */}
    </Aux>
  );
}

export default Skills;



// WEBPACK FOOTER //
// ./src/components/Recruiter/Skills/Skills.js